import Nullstack from 'nullstack';
export default function IconScreenshot({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-screenshot",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 19a2 2 0 0 1 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M5 13v-2"
  }), "   ", Nullstack.element("path", {
    d: "M5 7a2 2 0 0 1 2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M11 5h2"
  }), "   ", Nullstack.element("path", {
    d: "M17 5a2 2 0 0 1 2 2"
  }), "   ", Nullstack.element("path", {
    d: "M19 11v2"
  }), "   ", Nullstack.element("path", {
    d: "M19 17v4"
  }), "   ", Nullstack.element("path", {
    d: "M21 19h-4"
  }), "   ", Nullstack.element("path", {
    d: "M13 19h-2"
  }), " ");
}